import { render, staticRenderFns } from "./VersionUpdatePrompt.vue?vue&type=template&id=90182faa&scoped=true&"
import script from "./VersionUpdatePrompt.vue?vue&type=script&lang=js&"
export * from "./VersionUpdatePrompt.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdatePrompt.vue?vue&type=style&index=0&id=90182faa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90182faa",
  null
  
)

export default component.exports